package com.example.readingnotes.domain.model

data class User(
    val id: String, // UUID
    val username: String,
    val email: String? = null,
    val role: UserRole,
    val totpEnabled: Boolean,
    val defaultTenantId: String? = null, // UUID
    val activeTenantId: String? = null, // UUID
)
